/** Inside Sales operators cannot download a Pending sales-order PDF. Admins still can. */
export function insideSalesUserMayDownloadSalesOrderPdf(input: {
  isPendingOrder: boolean;
  isIntegratorAdmin: boolean;
  isInsideSalesAdmin: boolean;
}): boolean {
  if (!input.isPendingOrder) {
    return true;
  }
  return input.isIntegratorAdmin || input.isInsideSalesAdmin;
}
